import axiosInstance from './axiosMemoryApi';

export const GetMemories = (data) => axiosInstance.get('api/v1/memories/list', data);

export const GetSingleMemory = (data) => axiosInstance.get(`api/v1/memories/${data}`);

export const CreateMemory = (data) => axiosInstance.post('api/v1/memories',data);

export const EditMemory = (data,id) => axiosInstance.patch(`api/v1/memories/${id}`,data);